var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDownIcon = function SvgChevronDownIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.558058 1.05806C0.779947 0.836169 1.12717 0.815998 1.37184 0.997543L1.44194 1.05806L6 5.61583L10.5581 1.05806C10.7799 0.836169 11.1272 0.815998 11.3718 0.997543L11.4419 1.05806C11.6638 1.27995 11.684 1.62717 11.5025 1.87184L11.4419 1.94194L6.44194 6.94194C6.22005 7.16383 5.87283 7.184 5.62816 7.00246L5.55806 6.94194L0.558058 1.94194C0.313981 1.69786 0.313981 1.30214 0.558058 1.05806Z",
    fill: "black"
  })));
};
export default SvgChevronDownIcon;